import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
var DummyCanvas = function () {
    var canvasRef = useRef(null);
    useEffect(function () {
        var _a;
        var ctx = (_a = canvasRef.current) === null || _a === void 0 ? void 0 : _a.getContext('2d');
        var down = function () {
            ctx === null || ctx === void 0 ? void 0 : ctx.clearRect(0, 0, 1000, 1000);
        };
        var move = function () {
            ctx === null || ctx === void 0 ? void 0 : ctx.clearRect(0, 0, 1000, 1000);
            ctx === null || ctx === void 0 ? void 0 : ctx.moveTo(0, 0);
            ctx === null || ctx === void 0 ? void 0 : ctx.lineTo(10, 10);
        };
        var up = function () {
            ctx === null || ctx === void 0 ? void 0 : ctx.clearRect(0, 0, 1000, 1000);
        };
        if (ctx) {
            window.addEventListener('mousedown', down);
            window.addEventListener('mousemove', move);
            window.addEventListener('mouseup', up);
        }
        return function () {
            window.removeEventListener('mousedown', down);
            window.removeEventListener('mousemove', move);
            window.removeEventListener('mouseup', up);
        };
    }, [canvasRef]);
    return (_jsx("canvas", { ref: canvasRef, style: { position: 'absolute', width: '100%', height: '100%', zIndex: -1 }, width: 1000, height: 1000, "aria-hidden": "true" }));
};
export default DummyCanvas;
